import { TechnicianPage as TechnicianPageContext } from '@/pages/TechnicianPage/page'
import { DocumentPageDataProvider } from '@/pages/DocumentPage/queries'

export const TechnicianPage = () => {
  return (
    <DocumentPageDataProvider>
      <TechnicianPageContext />
    </DocumentPageDataProvider>
  )
}
